import { jsxs, jsx } from 'react/jsx-runtime';
import { useState } from 'react';
import { Globe } from '../../ui/icons/Globe.js';

const ChangeButton = ({ onClick, textLang = "한국어" }) => {
  const [currentLang, setCurrentLang] = useState(textLang);
  const toggleLanguage = () => {
    setCurrentLang((prev) => prev === "English" ? "한국어" : "English");
    onClick?.();
  };
  const getArialLabel = (lang) => {
    return lang === "한국어" ? "영문 페이지 바로가기" : "한글 페이지 바로가기";
  };
  return /* @__PURE__ */ jsxs(
    "button",
    {
      className: "btn-language",
      onClick: toggleLanguage,
      "aria-label": getArialLabel(currentLang === "English" ? "한국어" : "English"),
      children: [
        /* @__PURE__ */ jsx(Globe, { "aria-hidden": "true", fill: "#000" }),
        /* @__PURE__ */ jsx("span", { className: "w-[42px] text-center mt-[2px]", children: currentLang }),
        /* @__PURE__ */ jsx(
          "i",
          {
            className: "ico-arrow-sm",
            "aria-hidden": "true"
          }
        )
      ]
    }
  );
};

export { ChangeButton };
